<ui-section >
  <ui-form class="mb-6"
    [config]="formConfig"
    [(formValues)]="formValues"
  />
</ui-section>

<ui-section>
  <ui-tab-group
    [tabConfig]="tabs"
  />
</ui-section>
